import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useMechanicAuth } from '../context/MechanicAuthContext';

const MechanicProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useMechanicAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div className="auth-spinner" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/mechanic/login" state={{ from: location }} replace />;
  }

  return children;
};

export default MechanicProtectedRoute;
